import axios from '@/api/axios-config'
import type { Shift, ShiftCreateRequest, ShiftBatchCreateItem, ShiftBatchResult } from './types'
import type { SearchResponse } from '@/features/list-page/types'

export const shiftApi = {
  searchShifts: (params: any) =>
    axios.post<any, SearchResponse<Shift>>('/pms/schedules/search', params),

  getShifts: (params?: Record<string, any>) =>
    axios.get<any, { results: Shift[]; pagination: any }>('/pms/schedules', { params }),

  getMyShifts: (dateFrom?: string, dateTo?: string) => {
    const params: Record<string, string> = {}
    if (dateFrom) params.date_from = dateFrom
    if (dateTo) params.date_to = dateTo
    return axios.get<any, Shift[]>('/pms/schedules/my', { params })
  },

  getShift: (id: string, loadRelationships?: string[]) => {
    const params = new URLSearchParams()
    loadRelationships?.forEach(r => params.append('load_relationships', r))
    return axios.get<any, Shift>(`/pms/schedules/${id}?${params.toString()}`)
  },

  createShift: (data: ShiftCreateRequest) =>
    axios.post<any, Shift>('/pms/schedules', data),

  batchCreateShifts: (items: ShiftBatchCreateItem[], onConflict: 'skip' | 'replace' = 'skip') =>
    axios.post<any, ShiftBatchResult>('/pms/schedules/batch', items, { params: { on_conflict: onConflict } }),

  updateShift: (id: string, data: Partial<ShiftCreateRequest>) =>
    axios.put<any, Shift>(`/pms/schedules/${id}`, data),

  deleteShift: (id: string) =>
    axios.delete(`/pms/schedules/${id}`),
}
